module.exports = require("punycode");


//////////////////
// WEBPACK FOOTER
// external "punycode"
// module id = 61
// module chunks = 0